(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BannerImageController', BannerImageController);

    BannerImageController.$inject = ['$state', 'BannerImage', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BannerImageController($state, BannerImage, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterData = filterData;
        vm.filterLang = pagingParams.filterLang;

        loadAll();

        function loadAll () {
            BannerImage.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                appLang: vm.filterLang,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bannerImages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                filterLang: vm.filterLang
            });
        }

        function filterData() {
            loadAll();
        }
    }
})();
